/* ============================================================
   ENGRAM · assets/engram-help.js — centro de ajuda (ecrã 3c)
   No desktop, o «Ainda com dúvidas» é um cartão na coluna da esquerda das perguntas (secção collapsible-tabs do tema,
   logo antes de sections/engram-help-contact). Aqui copia-se o <template data-engram-help-card> para o cabeçalho
   dessas perguntas e marca-se a banda (.engram-help-contact--placed), que o CSS esconde a partir de 990px.
   Sem perguntas antes, ou sem script, a banda escura fica em todos os tamanhos.
   ============================================================ */
(function () {
  function place(band) {
    var section = band.closest('.shopify-section');
    var template = section && section.querySelector('template[data-engram-help-card]');
    var prev = section && section.previousElementSibling;
    var header = prev && prev.querySelector('.collapsible-tabs__header');
    if (!template || !header) return;
    var old = header.querySelector('.engram-help-card');
    if (old) old.remove();
    header.appendChild(template.content.cloneNode(true));
    band.classList.add('engram-help-contact--placed');
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-engram-help-contact]'), place);
  }

  init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  // «Abrir o chat» sem link abre o chat do CommSlayer (app embed ligado no tema, 22 Out 2026); sem o chat, não faz nada
  if (!window.engramHelpChat) {
    window.engramHelpChat = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-engram-help-chat]');
      if (button && window.$chatwoot) window.$chatwoot.toggle('open');
    });
  }
})();
